import * as sections from "components/Homeowner/CaseForms/ComparableGrid/Sections/Sections";
export const FannieMaeHybridSections = [
  sections.FEATURE,
  sections.COMPARABLE_TYPE,
  sections.ADDRESS,
  sections.LATITUDE,
  sections.LONGITUDE,
  sections.ADDRESS_2,
  sections.CITY,
  sections.STATE,
  sections.ZIP,
  sections.PROXIMITY_TO_SUBJECT,
  sections.SALE_PRICE,
  sections.FINAL_LIST_PRICE,
  sections.SALE_PRICE_GLA,
  sections.DATA_SOURCES_FNMA,
  sections.VERIFICATION_SOURCES,
  sections.DAYS_ON_MARKET,
  sections.CDOM,
  sections.VALUE_ADJUSTMENTS,
  sections.SALE_FNMA,
  sections.SALE_DATE_FNMA,
  sections.PROPERTY_TYPE,
  sections.NUM_OF_UNITS,
  sections.YEAR_BUILT,
  sections.LOCATION,
  sections.LOCATION_RATING,
  sections.LOCATION_TYPE,
  sections.LOCATION_TYPE_2,
  sections.LEASEHOLD_FEE_SIMPLE,
  sections.SITE,
  sections.SQUARE_FEET,
  sections.ACRES,
  sections.ADJUSTMENTS_SITE,
  sections.VIEW,
  sections.VIEW_RATING,
  sections.VIEW_TYPE,
  sections.VIEW_TYPE_2,
  sections.DESIGN_STYLE,
  sections.ATT_DET,
  sections.STORIES,
  sections.DESIGN,
  sections.QUALITY,
  sections.CONDITION,
  sections.NUM_OF_FLOORS,
  sections.FLOOR_LOCATION,
  sections.MONTHLY_RENTAL_RATE,
  sections.ABOVE_GRADE,
  sections.ABOVE_GRADE_ROOM_COUNT,
  sections.TOTAL,
  sections.BEDROOMS,
  sections.BATHROOMS,
  sections.HALF_BATHROOMS,
  sections.ADJUSTMENTS_ROOM_COUNT,
  sections.GLA,
  sections.ADJUSTMENTS_GLA,
  sections.BASEMENT_FINISHED,
  sections.BELOW_GRADE_TOT_SF,
  sections.BELOW_GRADE_FIN_SF,
  sections.BASEMENT_EXIT_TYPE,
  sections.BELOW_GRADE_ROOM_COUNT_FNMA,
  sections.HEATING_FNMA,
  sections.COOLING_FNMA,
  sections.GARAGE_CARPORT,
  sections.DRIVEWAY,
  sections.NUM_OF_CARS,
  sections.CAR_STORAGE_1,
  sections.ATTACHMENT_TYPE_1,
  sections.NUM_OF_CARS_1,
  sections.CAR_STORAGE_2,
  sections.ATTACHMENT_TYPE_2,
  sections.NUM_OF_CARS_2,
  sections.PORCH_PATIO_DECK,
  sections.PORCH,
  sections.PATIO_DECK,
  sections.POOL,
  sections.OTHER_NAME_1,
  sections.OTHER_1_DESC,
  sections.OTHER_NAME_2,
  sections.OTHER_2_DESC,
  sections.OTHER_NAME_3,
  sections.OTHER_3_DESC,
  sections.NET_ADJ,
  sections.ADJ_NET_PRICE,
  sections.ADJ_GROSS_PRICE,
];

export const FannieMaeHybridComparableCount = {
  minComparables: 6,
  maxComparables: 15
};